<!--<div class="flex align-items-center gap-2">
  <i class="pi pi-lightbulb"></i>
  <span>{{'FEATURE_WILL_BE_AVAILABLE_SOON' | translate}}</span>
</div>-->

<div class="flex align-items-center gap-2">
  <span>{{ 'ACCOUNT_STATUS' | translate }}:</span>
  <app-player-profile-payment-status [playerProfile]="playerProfile" [longStatus]="true"/>
  <div class="flex-1"></div>

  <p-button styleClass="p-button-text" icon="pi pi-lightbulb"
            [label]="view.isMobile ? '' : ('DISCOVER_ALL_ADVANTAGES_OF_PLAYER_PROFILE' | translate)"
            (click)="openPlayerProfileFeatures()"/>
</div>
<p-divider/>

<app-loading [active]="isLoadingSettings"/>
<app-message [active]="!!errorMsgSettings" [message]="errorMsgSettings"/>
@if (settings && showPurchase) {
  @if (settings?.pricePremiumYear > 0) {
    <div class="flex align-items-center gap-2 text-lg">
      <div>{{'COSTS' | translate}}:</div>
      <div>{{ 'PLAYER_PROFILE_FEE_PRO_COSTS_TEXT' | translate: {value: settings.pricePremiumYear | number: '1.2-2'} }}</div>
    </div>
  }
  <div class="pt-2">
    @if (settings.paymentActive) {
      <p-button icon="pi pi-shopping-cart"
                [disabled]="isPurchasing || errorMsgPurchase" [loading]="isPurchasing"
                [label]="'PLAYER_PROFILE_BUY_PRO_ACCOUNT_12_MONTHS' | translate"
                (click)="buyProAccount12Months()"/>
    } @else {
      <p class="text-frontend-accent-gray">{{'PAYMENT_NOT_ACTIVE' | translate}}</p>
    }
  </div>
  <div class="pt-2">
    @if (errorMsgPurchase) {
      <app-message [active]="!!errorMsgPurchase" [message]="errorMsgPurchase"/>
      <div class="pt-3">
        <p-button icon="pi pi-id-card" class="grid-comp-full-width"
                  [label]="'EDIT_PERSONAL_DATA' | translate"
                  routerLink="/frontend/player/profile/account/personalData"/>
      </div>
    } @else {
      <app-info-text text="PLAYER_PROFILE_BUY_PRO_ACCOUNT_TEXT" color="text-gray-400"/>
    }
  </div>

  <p-divider/>
}
@if (showPurchaseIOS) {
  <div>
    <b>{{ 'SUBSCRIPTION' | translate }}:</b>&nbsp;{{ 'IOS_SUBSCRIPTION_NAME_1_YEAR' | translate }}
  </div>
  <div class="pt-1">
    <b>{{ 'PRICE' | translate }}:</b>&nbsp;{{ appleSubsriptionStatus?.price ? appleSubsriptionStatus.price : '24,99 €' }}&nbsp;{{ 'PER_YEAR' | translate }}
  </div>
  <div class="pt-2">
    {{ 'IOS_SUBSCRIPTION_DESCRIPTION' | translate }}
  </div>
  <div class="pt-2">
    <b>{{ 'TERMS_OF_USE' | translate }}:</b>&nbsp;<a href="https://www.apple.com/legal/internet-services/itunes/dev/stdeula/" target="_blank">https://www.apple.com/legal/internet-services/itunes/dev/stdeula/</a>
  </div>
  <div class="pt-1 pb-3">
    <b>{{ 'PRIVACY_POLICY' | translate }}:</b>&nbsp;<a (click)="openPrivacyPolicy()" class="underline cursor-pointer">{{ 'SHOW_PRIVACY_POLICE' | translate}}</a>
  </div>

  @if (appleSubscrptionActiveAndValid) {
    <p-button icon="pi pi-apple"
              [disabled]="isPurchasing || errorMsgPurchase" [loading]="isPurchasing"
              [label]="'PLAYER_PROFILE_OPEN_APP_STORE_SUBSCRIPTIONS_IOS' | translate"
              (click)="managerProAccountApple()"/>
  } @else {
    <p-button icon="pi pi-apple"
              [disabled]="isPurchasing || errorMsgPurchase" [loading]="isPurchasing"
              [label]="'PLAYER_PROFILE_MANAGE_PRO_ACCOUNT_IOS' | translate"
              (click)="buyProAccountApple()"/>
  }
  <div class="pt-2">
    <app-info-text text="PLAYER_PROFILE_MANAGE_PRO_ACCOUNT_IOS_TEXT" color="text-gray-400"/>
  </div>
  <p-divider/>
}

<app-loading [active]="isLoading && !payments"/>
<app-message [active]="!!errorMsg" [message]="errorMsg"/>

@if ((!isLoading || payments) && !errorMsg && !errorMsgPurchase) {
  @if (payments?.length > 0) {
    <h3>{{'PAYMENTS' | translate}}</h3>
    <app-generic-list class="frontend smart" [frontend]="true"
                      [data]="payments"
                      [columns]="columns" [columnsMobile]="columnsMobile"
                      [scrollable]="false" [selectionMode]="undefined"
                      [mobileRowTemplate]="mobileRowTemplate"
                      [rowEdit]="false"
                      [rowDelete]="true" (onRowDelete)="deleteItem($event)"
                      [dataLoading]="isLoading"

                      [rowCustomButton]="" [rowCustomButtonIcon]="'pi pi-file-pdf'"
                      [rowCustomButtonClass]="'p-button-rounded p-button-text p-button-primary'"
                      [rowCustomButtonTooltip]="'INVOICE' | translate"
                      (onRowCustomButton)="createInvoice($event)"

                      [sortable]="true" [sortOrder]="-1" [sortField]="'date'"/>

    <div class="pt-2">
      <p-button icon="pi pi-refresh" (onClick)="loadData()" styleClass="p-button-text"
                [label]="'REFRESH' | translate"/>
    </div>

    @if (hasExpiredOrPedingItems) {
      <div class="pt-2">
        <app-info-text text="PLAYER_PROFILE_EXIPRED_OR_PENDING_ITEMS_TEXT" color="text-orange-frontend"/>
      </div>
    }
  } @else {
    <p>
      {{ 'NO_PAYMENTS_YET' | translate }}
    </p>
  }
}

<ng-template #paymentStatusTemplate let-item="data" pTemplate="item">
  <span [class.red]="item.paymentStatus === 'canceled'"
        [class.text-orange-frontend]="item.paymentStatus === 'expired'"
        [class.green]="item.paymentStatus === 'success' || item.paymentStatus === 'paid'">
    {{item.paymentStatus | domainValuePipe: 'payment-status'}}
  </span>
</ng-template>

<ng-template #paymentDetailsTemplate let-item="data" pTemplate="item">
  <div>
    @if (item.accountCd) {
      <div>
        {{'TYPE' | translate}}: {{item.accountCd | domainValuePipe: 'payment-account'}}
      </div>
    }
    @if (item.methodCd) {
      <div class="text-gray-400">
        {{item.methodCd | domainValuePipe: 'faktura_payment_method'}}
        @if (item.vendorCd) {
          ({{item.vendorCd | domainValuePipe: 'payment-vendor'}})
        }
      </div>
    }
  </div>
</ng-template>

<ng-template #mobileRowTemplate let-item="data" pTemplate="item">
  <td>
    <div class="flex align-items-center gap-2">
      <div class="flex-1">
        {{item.date | date: 'medium'}}
      </div>
      <div>
        @if (system() === 'ios') {
          {{item.vendorCd | domainValuePipe: 'payment-vendor'}}
        } @else {
          {{item.amount | currency: 'EUR' : 'symbol' : '1.2-2'}}
        }
      </div>
    </div>
    <div class="flex align-items-center gap-2 text-gray-400 pt-1">
      <div class="flex-1">
        {{'DATE_TO' | translate}}:&nbsp;{{item.paymentDateTo}}&nbsp;({{item.paymentMonthsDays}})
      </div>
      <div>
        {{'STATUS' | translate}}:
        <ng-container [ngTemplateOutlet]="paymentStatusTemplate" [ngTemplateOutletContext]="{data: item}"/>
      </div>
    </div>
    <div class="flex align-items-center gap-2 text-gray-400 pt-1">
      <div class="flex-1">
        {{item.accountCd | domainValuePipe: 'payment-account'}}, {{'TYPE' | translate}}:&nbsp;{{item.typeCd | domainValuePipe: 'payment-type'}}
      </div>
    </div>
    @if (item.success && item.methodCd) {
      <div class="pt-1 text-gray-400">
        {{item.methodCd | domainValuePipe: 'faktura_payment_method'}}
        @if (item.vendorCd) {
          ({{item.vendorCd | domainValuePipe: 'payment-vendor'}})
        }
      </div>
    }
  </td>
</ng-template>
